export function pxToVw(px: number | string, baseWidth: number = 1080): string {
  if (px === undefined || px === null) return "0vw";

  const numericPx =
    typeof px === "string" ? parseFloat(px.replace("px", "")) : px;

  if (isNaN(numericPx) || baseWidth === 0) return "0vw";

  const vwValue = (numericPx / baseWidth) * 100;

  // round to 2 decimal places
  const rounded = Math.round(vwValue * 100) / 100;

  return `${rounded}`;
}
